import {
    Alert,
    Button,
    Card,
    CardMedia,
    Checkbox,
    FormControlLabel,
    Grid,
    Typography,
} from '@mui/material'
import banner from '../../../assets/disclaimer_banner.svg'
import { Trans, useTranslation } from 'react-i18next'
import { LoadingButton } from '@mui/lab'
import { ChangeEvent, useEffect, useState } from 'react'
import { SignupRoute, SignupRouteParams } from '../SignupFlow/SignupFlow'
import { getPLSMyInfoURL } from '../../../services/ntuc/memberService/myinfo'
import { postUserLogin } from '../../../services/ntuc/userService/login'

function DisclaimerPage(props: SignupRouteParams) {
    const { onNavigateTo } = props
    const { t } = useTranslation(`disclaimer`)
    const [loading, setLoading] = useState(false)
    const [accept, setAccept] = useState(!window.myNtucConfig.authToken)

    const membershipLinkingConsent = t(`membershipLinkingConsent`)
    const handleManualApplicationClick = () => {
        onNavigateTo(SignupRoute.Form)
    }

    const handleMyInfoApplicationClick = () => {
        setLoading(true)

        getPLSMyInfoURL()
            .then((response) => {
                window.location.replace(response.data)
                console.log(`Successfully redirect user to MyInfo`)
            })
            .catch((err) => {
                console.error(err)
                setLoading(false)
            })
    }

    const handleCheckBoxOnChange = (_event: ChangeEvent<HTMLInputElement>, checked: boolean) => {
        setAccept(checked)
    }

    useEffect(() => {
        if (window.myNtucConfig.authToken) {
            postUserLogin()
                .then(() => {
                    console.log(`Succesfully logged in user to backend`)
                })
                .catch(console.error)
        }
    }, [])

    const ConsentCheckbox = () => {
        if (window.myNtucConfig.authToken) {
            return (
                <Grid container
                    justifyContent="center"
                    alignItems="center"
                    item md={12}>
                    <FormControlLabel
                        control={<Checkbox checked={accept} onChange={handleCheckBoxOnChange} />}
                        label={membershipLinkingConsent} />
                </Grid>
            )
        } else {
            return (<div />)
        }
    }

    return (
        <Grid container rowSpacing={3} padding={2} justifyContent="center">
            <Grid item xs={12}>
                <Typography variant='h1' align='center'>{t(`title`)}</Typography>
            </Grid>
            <Grid item m='auto' xs={12} hidden={!banner}>
                <Grid container justifyContent="center">
                    <Grid item xs={12} md={8}>
                        <Card sx={{ border: `none`, boxShadow: `none` }}>
                            <CardMedia
                                sx={{ width: `100%`, objectFit: `contain`, borderRadius: { xs: `20px`, md: `50px` } }}
                                component="img"
                                image={banner}
                                alt="Disclaimer Banner"
                            />
                        </Card>
                    </Grid>
                </Grid>
            </Grid>
            <Grid item md={6} xs={12}>
                <Typography variant="body1">
                    <strong>{t(`notes.title`)}</strong>
                </Typography>
                <ul>
                    <Trans t={t}>notes.description</Trans>
                </ul>
            </Grid>
            <Grid item md={6} xs={12}>
                <Typography variant="body1" color='error'>
                    <strong>{t(`exclusions.title`)}</strong>
                </Typography>
                <ul>
                    <Trans t={t}>exclusions.description</Trans>
                </ul>
            </Grid>
            <ConsentCheckbox />
            <Grid item md={12}>
                <Alert severity="info">
                    <Trans t={t}>info</Trans>
                </Alert>
            </Grid>
            <Grid container item xs={8} sm={6} justifyContent="center">
                <Grid item xs={12} md={6}>
                    <LoadingButton disabled={!accept} loading={loading} size="large" variant="contained" color="primary" onClick={handleMyInfoApplicationClick} fullWidth>
                        {t(`button.my_info`)}
                    </LoadingButton>
                </Grid>
            </Grid>
            <Grid container item xs={8} sm={6} justifyContent="center">
                <Grid item xs={12} md={6}>
                    <Button disabled={!accept} onClick={handleManualApplicationClick} variant="outlined" size='large' color="primary" fullWidth>
                        {t(`button.manual`)}
                    </Button>
                </Grid>
            </Grid>
        </Grid>
    )
}

export default DisclaimerPage
